/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Feedback } from '../../models/feedback';
import { FeedbackApiRespModel } from '../../models/feedback-api-resp-model';

export interface ApiRequestFeedbackSavePost$Params {
      body?: Feedback
}

export function apiRequestFeedbackSavePost(http: HttpClient, rootUrl: string, params?: ApiRequestFeedbackSavePost$Params, context?: HttpContext): Observable<StrictHttpResponse<FeedbackApiRespModel>> {
  const rb = new RequestBuilder(rootUrl, apiRequestFeedbackSavePost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<FeedbackApiRespModel>;
    })
  );
}

apiRequestFeedbackSavePost.PATH = '/api/request/feedback/Save';
